import { useSetAtom } from "jotai";
import { useModals } from "src/components/Modals";
import { deleteStorePogModalAtom } from "./atoms";

interface OpenDeleteStorePogModalData {
  storePogIds: number[];
  approvedCount: number;
  inProgressCount: number;
  isLastPog: boolean;
  merchflowId: number;
  onSuccess: () => void;
}

export const useDeleteStorePogModal = () => {
  const { openModal } = useModals();
  const setData = useSetAtom(deleteStorePogModalAtom);

  const openDeleteStorePogModal = (data: OpenDeleteStorePogModalData) => {
    setData(data);
    openModal("ModalDeleteStorePogs");
  };

  return { openDeleteStorePogModal };
};
